<template>
  <v-card flat class="ai-chat-settings">
    <custom-tabs v-model="activeTab" grow>
      <template v-slot:staticTabs>
        <!-- تب انتخاب دستیار -->
        <v-tab :ripple="false">
          <div class="cornel-left" />
          <div class="cornel-right" />
          <div class="d-flex align-center">
            <v-icon class="me-2">mdi-robot</v-icon>
            {{ $t("aiChatSettings.select_assistant") }}
          </div>
        </v-tab>

        <!-- تب تنظیمات ظاهری -->
        <v-tab :ripple="false">
          <div class="cornel-left" />
          <div class="cornel-right" />
          <div class="d-flex align-center">
            <v-icon class="me-2">mdi-palette</v-icon>
            {{ $t("aiChatSettings.appearance_settings") }}
          </div>
        </v-tab>

        <!-- تب تنظیمات لید -->
        <v-tab :ripple="false">
          <div class="cornel-left" />
          <div class="cornel-right" />
          <div class="d-flex align-center">
            <v-icon class="me-2">mdi-account-outline</v-icon>
            {{ $t("aiChatSettings.lead_connection_tab") }}
          </div>
        </v-tab>
      </template>

      <template v-slot:middle>
        <div class="py-3" />
      </template>

      <template v-slot:staticItems>
        <!-- محتوای تب انتخاب دستیار -->
        <v-tab-item>
          <assistant-ai-list
            v-model="computedValue.assistantId"
            @change="onAssistantChange"
          />
        </v-tab-item>

        <!-- محتوای تب تنظیمات ظاهری -->
        <v-tab-item>
          <v-card flat class="pa-2">
            <v-expansion-panels v-model="openPanel" accordion flat>
              <!-- 1. آکاردئون هدر -->
              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="primary" class="ml-3">
                      <v-icon color="white" small
                        >mdi-page-layout-header</v-icon
                      >
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">
                        {{ $t("aiChatSettings.header_settings") }}
                      </div>
                      <div class="text-caption grey--text">
                        {{ $t("aiChatSettings.header_settings_desc") }}
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="primary">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <!-- سوئیچ رنگ تکی/گرادیان -->
                  <v-switch
                    v-model="computedValue.chatSettings.headerGradient"
                    :label="
                      computedValue.chatSettings.headerGradient
                        ? $t('aiChatSettings.gradient_color')
                        : $t('aiChatSettings.solid_color')
                    "
                    dense
                    inset
                    color="primary"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <!-- رنگ‌های گرادیان -->
                  <v-row v-if="computedValue.chatSettings.headerGradient">
                    <v-col cols="12" md="6">
                      <color-picker
                        v-model="computedValue.chatSettings.headerColor"
                        :label="$t('aiChatSettings.first_color')"
                        @input="emitUpdate"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <color-picker
                        v-model="computedValue.chatSettings.headerColor2"
                        :label="$t('aiChatSettings.second_color')"
                        @input="emitUpdate"
                      />
                    </v-col>
                  </v-row>

                  <!-- رنگ تکی -->
                  <color-picker
                    v-else
                    v-model="computedValue.chatSettings.headerColor"
                    :label="$t('aiChatSettings.header_color')"
                    @input="emitUpdate"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- 2. آکاردئون متن -->
              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="deep-purple" class="ml-3">
                      <v-icon color="white" small>mdi-format-text</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">
                        {{ $t("aiChatSettings.text_settings") }}
                      </div>
                      <div class="text-caption grey--text">
                        {{ $t("aiChatSettings.text_settings_desc") }}
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="deep-purple">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <color-picker
                    v-model="computedValue.chatSettings.textColor"
                    :label="$t('aiChatSettings.text_color')"
                    @input="emitUpdate"
                  />

                  <div class="mt-4">
                    <v-slider
                      v-model="computedValue.chatSettings.fontSize"
                      :min="12"
                      :max="20"
                      :step="1"
                      thumb-label="always"
                      :label="$t('aiChatSettings.font_size')"
                      color="deep-purple"
                      track-color="grey lighten-2"
                      @input="emitUpdate"
                    >
                      <template v-slot:append>
                        <span class="text-body-2">
                          {{ computedValue.chatSettings.fontSize }}px
                        </span>
                      </template>
                    </v-slider>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- 3. آکاردئون لوگو -->
              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="teal" class="ml-3">
                      <v-icon color="white" small>mdi-image</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">
                        {{ $t("aiChatSettings.logo_settings") }}
                      </div>
                      <div class="text-caption grey--text">
                        {{ $t("aiChatSettings.logo_settings_desc") }}
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="teal">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <v-switch
                    v-model="computedValue.chatSettings.useImageLogo"
                    :label="
                      computedValue.chatSettings.useImageLogo
                        ? $t('aiChatSettings.use_image')
                        : $t('aiChatSettings.use_icon')
                    "
                    dense
                    inset
                    color="teal"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <pic-selector
                    v-if="computedValue.chatSettings.useImageLogo"
                    :field="computedValue.chatSettings.chatLogo"
                    @update:field="updateLogoImage"
                    :edit-name="false"
                    :default-cat-name="$t('aiChatSettings.logo_settings')"
                    one-pic
                    single
                  />

                  <div v-else>
                    <v-select
                      v-model="computedValue.chatSettings.floatingIcon"
                      :items="floatingIcons"
                      item-text="translatedText"
                      item-value="value"
                      :label="$t('aiChatSettings.logo_settings')"
                      outlined
                      dense
                      @change="emitUpdate"
                    >
                      <template v-slot:selection="{ item }">
                        <v-icon class="ml-2" color="teal">{{
                          item.value
                        }}</v-icon>
                        {{ item.translatedText }}
                      </template>
                      <template v-slot:item="{ item }">
                        <v-icon class="ml-2">{{ item.value }}</v-icon>
                        {{ item.translatedText }}
                      </template>
                    </v-select>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- 4. آکاردئون پس‌زمینه -->
              <v-expansion-panel class="settings-panel mb-3">
                <v-expansion-panel-header class="settings-panel-header">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="orange" class="ml-3">
                      <v-icon color="white" small>mdi-palette-swatch</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">
                        {{ $t("aiChatSettings.background_settings") }}
                      </div>
                      <div class="text-caption grey--text">
                        {{ $t("aiChatSettings.background_settings_desc") }}
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon color="orange">mdi-chevron-down</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <v-switch
                    v-model="computedValue.chatSettings.useImageBackground"
                    :label="
                      computedValue.chatSettings.useImageBackground
                        ? $t('aiChatSettings.use_image')
                        : $t('aiChatSettings.solid_color')
                    "
                    dense
                    inset
                    color="orange"
                    class="mb-4"
                    @change="emitUpdate"
                  />

                  <pic-selector
                    v-if="computedValue.chatSettings.useImageBackground"
                    :field="computedValue.chatSettings.backgroundImage"
                    @update:field="updateBackgroundImage"
                    :edit-name="false"
                    :default-cat-name="$t('aiChatSettings.background_settings')"
                    one-pic
                    single
                  />

                  <color-picker
                    v-else
                    v-model="computedValue.chatSettings.backgroundColor"
                    :label="$t('aiChatSettings.background_color')"
                    @input="emitUpdate"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-tab-item>

        <!-- تب دریافت لید -->
        <v-tab-item>
          <v-card flat class="pa-4">
            <v-card-subtitle class="font-weight-bold mb-4">
              {{ $t("aiChatSettings.lead_connection_title") }}
            </v-card-subtitle>

            <v-alert type="info" border="left" colored-border>
              {{ $t("aiChatSettings.lead_alert") }}
            </v-alert>

            <v-card class="chat-preview-window rounded-xl elevation-8 pa-4">
              <v-switch
                class="px-1"
                v-model="computedValue.hasAssistantsName"
                dense
                inset
                :label="$t('aiChatSettings.hasAssistantsName_label')"
                :hint="$t('aiChatSettings.hasAssistantsName_hint')"
                @change="emitLeadSettingsUpdate"
                persistent-hint
              />
              <v-switch
                class="px-1"
                v-model="computedValue.hasAssistantsFamily"
                dense
                inset
                :label="$t('aiChatSettings.hasAssistantsFamily_label')"
                :hint="$t('aiChatSettings.hasAssistantsFamily_hint')"
                @change="emitLeadSettingsUpdate"
                persistent-hint
              />
              <v-switch
                class="px-1"
                v-model="computedValue.hasAssistantsMobile"
                dense
                inset
                :label="$t('aiChatSettings.hasAssistantsMobile_label')"
                :hint="$t('aiChatSettings.hasAssistantsMobile_hint')"
                @change="emitLeadSettingsUpdate"
                persistent-hint
              />
            </v-card>
          </v-card>
        </v-tab-item>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import AssistantAiList from "./assistantAiList.vue";
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";

export default {
  name: "aiChatSettings",

  components: {
    AssistantAiList,
    ColorPicker,
    PicSelector,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      openPanel: false,
      activeTab: 0,
    };
  },

  computed: {
    computedValue: {
      get() {
        const defaults = {
          assistantId: null,
          assistant: null,
          hasAssistantsName: false,
          hasAssistantsFamily: false,
          hasAssistantsMobile: false,
          chatSettings: {
            headerColor: "#667eea",
            headerColor2: "#764ba2",
            headerGradient: true,
            backgroundColor: "#ffffff",
            backgroundImage: null,
            useImageBackground: false,
            textColor: "#333333",
            fontSize: 14,
            chatLogo: null,
            floatingIcon: "mdi-robot",
            useImageLogo: false,
          },
        };
        return {
          ...defaults,
          ...this.value,
          chatSettings: {
            ...defaults.chatSettings,
            ...(this.value?.chatSettings || {}),
          },
        };
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    floatingIcons() {
      return [
        { value: "mdi-robot", translatedText: this.$t("aiChatSettings.robot") },
        { value: "mdi-chat", translatedText: this.$t("aiChatSettings.chat") },
        {
          value: "mdi-headset",
          translatedText: this.$t("aiChatSettings.support"),
        },
        {
          value: "mdi-help-circle",
          translatedText: this.$t("aiChatSettings.question"),
        },
        {
          value: "mdi-message",
          translatedText: this.$t("aiChatSettings.message"),
        },
        {
          value: "mdi-account-voice",
          translatedText: this.$t("aiChatSettings.assistant_voice"),
        },
        {
          value: "mdi-brain",
          translatedText: this.$t("aiChatSettings.ai_brain"),
        },
      ];
    },
  },

  methods: {
    updateLogoImage(val) {
      const newSettings = {
        ...this.computedValue.chatSettings,
        chatLogo: val,
      };
      this.$emit("input", { ...this.value, chatSettings: newSettings });
    },

    updateBackgroundImage(val) {
      const newSettings = {
        ...this.computedValue.chatSettings,
        backgroundImage: val,
      };
      this.$emit("input", { ...this.value, chatSettings: newSettings });
    },

    emitUpdate() {
      this.$emit("input", {
        ...this.value,
        chatSettings: { ...this.computedValue.chatSettings },
      });
    },
    emitLeadSettingsUpdate() {
      this.$emit("input", {
        ...this.value,
        hasAssistantsName: this.computedValue.hasAssistantsName,
        hasAssistantsFamily: this.computedValue.hasAssistantsFamily,
        hasAssistantsMobile: this.computedValue.hasAssistantsMobile,
        chatSettings: { ...this.computedValue.chatSettings },
      });
    },
    onAssistantChange(assistant) {
      if (assistant) {
        const newValue = {
          ...this.value,
          assistant: assistant,
          assistantId: assistant.id,
          chatSettings: { ...this.computedValue.chatSettings },
        };
        this.$emit("input", newValue);
        this.$nextTick(() => {
          this.activeTab = 1;
        });
      } else {
        const newValue = {
          ...this.value,
          assistant: null,
          assistantId: null,
          chatSettings: { ...this.computedValue.chatSettings },
        };
        this.$emit("input", newValue);
      }
    },
  },
};
</script>

<style scoped>
.ai-chat-settings {
  background: transparent;
}

.chat-preview-container {
  position: relative;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
}

.floating-preview-btn {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 10;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(102, 126, 234, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0);
  }
}

.chat-preview-window {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 8px;
}

.chat-preview-header {
  padding: 12px 16px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.chat-preview-content {
  flex: 1;
  overflow-y: auto;
}

.chat-preview-input {
  background: #fafafa;
  border-top: 1px solid #e0e0e0;
}

.message-preview {
  display: flex;
  align-items: flex-start;
}

.message-preview.user-msg {
  justify-content: flex-end;
}

.message-bubble {
  background: #f5f5f5;
  padding: 12px 16px;
  border-radius: 18px 18px 18px 4px;
  max-width: 80%;
}

.user-bubble {
  color: white;
  border-radius: 18px 18px 4px 18px;
}
/* استایل آکاردئون‌ها */
.settings-panel {
  border: 1px solid #e0e0e0;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

.settings-panel:hover {
  border-color: #bdbdbd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.settings-panel-header {
  min-height: 64px;
  padding: 12px 16px;
}

.settings-panel.v-expansion-panel--active {
  border-color: var(--v-primary-base);
}

/* استایل رنگ‌ها */
.color-label {
  font-size: 13px;
  font-weight: 600;
  color: #616161;
}

.color-swatch {
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.color-swatch:hover {
  transform: scale(1.15);
  border-color: rgba(0, 0, 0, 0.2);
}

.gradient-swatch {
  width: 48px;
  height: 32px;
  border-radius: 8px;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.gradient-swatch:hover {
  transform: scale(1.1);
  border-color: rgba(0, 0, 0, 0.2);
}

.icon-preview-box {
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  border-radius: 12px;
}

.cursor-pointer {
  cursor: pointer;
}
/* استایل آکاردئون‌ها */
.settings-panel {
  border: 1px solid #e0e0e0;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

.settings-panel:hover {
  border-color: #bdbdbd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.settings-panel-header {
  min-height: 64px;
  padding: 12px 16px;
}

.settings-panel.v-expansion-panel--active {
  border-color: var(--v-primary-base);
}
</style>
